<template>
<div>
<ContentHeader :title="$store.state.languages.lang_phrases.verification"  :show_button="false" ></ContentHeader>



<template v-if="loading">
<FrameOverlay></FrameOverlay>
</template>




<template v-if="!loading">
<div class="mt-4">

<div class="grid">

<template v-if="$store.state.flows.flow.questionlist">
  <div class="col-11">
  <ClickEditSelect title="Soru Listesi" :value="flowquestionlist" :options="questionlists" valkey="questionlist" @dataChanged="dataChanged"  :filter="true"/>
  </div>
  <div class="col-1">
<Button type="button"  icon="pi pi-external-link"  class="p-button-primary p-button-outlined p-button-sm mt-3"  @click="gotoQuList" />
  </div>

</template>

<template v-else>
  <div class="col-12">
    <ClickEditSelect title="Soru Listesi" :value="flowquestionlist" :options="questionlists" valkey="questionlist" @dataChanged="dataChanged"  :filter="true"/>
  </div>
</template>



</div>




<ClickEditSwitch  title="Tedarikçiler Gün Seçebilsin" :value="verificationsettings.allow_self_schedule" valkey="allow_self_schedule" @dataChanged="settingsChanged" />
<ClickEditSwitch  :title="$store.state.languages.lang_phrases.teknik_denetleme_gerekli" :value="verificationsettings.requires_tech_audit" valkey="requires_tech_audit" @dataChanged="settingsChanged" />

<ClickEditNumber  title="Max Seçilebilir Gün Sayısı" :value="verificationsettings.selectable_days_count" valkey="selectable_days_count" @dataChanged="settingsChanged" v-show="verificationsettings.allow_self_schedule"  />

<ClickEditNumber  title="Doğrulama Oturum Süresi(dakika)" :value="verificationsettings.session_duration" valkey="session_duration" @dataChanged="settingsChanged"   />

<ClickEditSwitch  :title="$store.state.languages.lang_phrases.donem_bittiginde_uygunsuzluk_kapatma" :value="verificationsettings.allow_closure_after_expire" valkey="allow_closure_after_expire" @dataChanged="settingsChanged" />

<!--<SortableArray :list="list"></SortableArray>-->

</div>
</template>
<FlowQuestionlistCloneModal @questionlistselected="questionlistselected"></FlowQuestionlistCloneModal>
</div>



</template>

<script>
import FlowQuestionlistCloneModal from "./FlowQuestionlistCloneModal"
export default {

  name: 'FlowVerification',

  data () {
    return {
      loading:true,
      flowquestionlist:null,
      questionlists:[],
      selectedquestionlist:{name:"Soru Listesi Seç",id:0},
      verificationsettings:null,
    }
  },
  components:{FlowQuestionlistCloneModal},
  mounted()
  {
    //this.$store.dispatch('ui/setActiveTab',"verification") 
    this.getData()
  },
  
  methods:{
    questionlistselected(fields)
    {
      let formdata = this.createFormData(JSON.parse(JSON.stringify(fields)))
      formdata.append("flow_id",this.$route.params.id) 
      formdata.append("questionlist_id",this.$store.state.flows.qu_list_to_clone.id)  
      this.generalSubmission(formdata,"questionlists/clone_list",this.afterquestionlistselected)
    },
    afterquestionlistselected(response)
    {
      this.$store.dispatch('flows/setShowCloneModal',false) 
      console.log(response.data) 
      this.gotoPage('Questionlist',{id:response.data.id})
    },    
    async getData()
    {
        this.verificationsettings = await this.$store.state.flows.flow.verificationsettings
        let questionlists = await this.generalApiGetWithoutLoader("questionlists")
        for(let questionlist of questionlists)
        {
          

          if(questionlist.brand_id == this.$store.state.flows.flow.brand_id)
          {
            questionlist.name = questionlist.name+" - "+ questionlist.brand.name
            
          }
          else
          {
            questionlist.name = questionlist.name+" - "+questionlist.brand.name+" - kopyasını oluştur"
          }
        }
        
        this.questionlists = await questionlists
        
        if(this.$store.state.flows.flow.questionlist)
        {
          this.flowquestionlist = await this.$store.state.flows.flow.questionlist
        }
        
        

        console.log(this.questionlists)
        this.loading = await false
    },
    dataChanged(data)
    {
      console.log(data)      
      if(data.value==0)
      {
        this.gotoPage('FlowNewQuestionlist')
      }
      else
      {

        let item = this.questionlists.find((item)=>{return item.id == data.value})
        console.log(item)
        console.log(this.$store.state.flows.flow.brand_id)
        if(item.brand_id !== this.$store.state.flows.flow.brand_id)
        {
          this.$store.dispatch('flows/setQuListToClone',item) 
          this.$store.dispatch('flows/setShowCloneModal',true) 
          return false
        }

        let formdata = new FormData()
        formdata.append("flow_id",this.$route.params.id) 
        formdata.append("questionlist_id",data.value) 
        this.generalSubmission(formdata,"questionlists/select_flow",this.afterSubmit)
      }
    },
    async afterSubmit(response)
    {
        console.log(response.data) 
        let item = await this.generalApiGetWithoutLoader("flow/"+this.$route.params.id) 
        this.$store.dispatch('flows/setFlow',item)
        this.flowquestionlist =  item.questionlist
        this.verificationsettings  = item.verificationsettings
       this.$store.state.flows.flow.verificationsettings = item.verificationsettings
      
    },
    gotoQuList()
    {
      console.log(this.$store.state.flows.flow.questionlist.id)
      this.gotoPage('Questionlist',{id:this.$store.state.flows.flow.questionlist.id})
    },
    settingsChanged(data)
    {
      console.log(data)
      let formdata = new FormData()
      formdata.append("verificationsettings_id",this.$store.state.flows.flow.verificationsettings.id) 
      formdata.append(data.key,data.value) 
      this.generalSubmission(formdata,"flow/verification_settings/"+this.$store.state.flows.flow.verificationsettings.id,this.aftersettingsChanged)
    },
    aftersettingsChanged(response)
    {
      console.log(response.data)
      this.verificationsettings  = response.data
      this.$store.state.flows.flow.verificationsettings = response.data
    },
  }
};
</script>

<style lang="css" scoped>
</style>